import axios from 'axios';

/**
 * Resolve the pokedex backend's Orka sub-path base URL.
 * Mirrors src/services/teamcityApi.js base resolution, with a /orka suffix.
 */
function resolveOrkaBase() {
  if (process.env.NODE_ENV === 'production') {
    return '/api/orka';
  }
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/orka`;
  }
  const hostname = window.location.hostname;
  return `http://${hostname}:3151/api/orka`;
}

const api = axios.create({
  baseURL: resolveOrkaBase(),
});

// Firebase Bearer token getter - wired by OrkaDashboard via setOrkaTokenGetter.
let tokenGetter = null;

export function setOrkaTokenGetter(fn) {
  tokenGetter = fn;
}

api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Nodes
export const getNodes = () => api.get('/nodes');

// VMs
export const getVMs = () => api.get('/vms');
export const createVM = (data) => api.post('/vms', data);
export const deleteVM = (vmName) => api.delete(`/vms/${vmName}`);

// VM snapshot - push a running VM to Harbor as an image
export const pushVM = (vmName, imageName, tag) =>
  api.post('/vms/push', { vm_name: vmName, image_name: imageName, tag });

// Images
export const getImages = () => api.get('/images');

// Image descriptions (user-editable, keyed by image name)
export const getImageDescriptions = () => api.get('/image-descriptions');
export const saveImageDescription = (name, description) =>
  api.put(`/image-descriptions/${encodeURIComponent(name)}`, { description });

// Delete a specific image tag from Harbor
export const deleteImageTag = (repo, tag) =>
  api.delete(`/images/${encodeURIComponent(repo)}/${encodeURIComponent(tag)}`);

// Build machines (VMs correlated with TC agents)
export const getBuildMachines = () => api.get('/build-machines');

// VM pool (nightly cache system)
export const getPool = () => api.get('/pool');
export const addPoolVM = (data) => api.post('/pool', data);
export const removePoolVM = (name) => api.delete(`/pool/${encodeURIComponent(name)}`);

// User-driven VM image builds (admin-only)
export const startImageBuild = (payload) => api.post('/image-build', payload);
export const getImageBuildJob = (jobId) => api.get(`/image-build/${encodeURIComponent(jobId)}`);

export default api;
